<script>
    import { mapGetters } from 'vuex'

    import Note from '@/components/Note'
    import store from '@/store'

    import { format } from 'date-fns'
    import EventBus from '../event-bus'

    export default {
        data () {
            return {
                format,
                visible : false,
                selected: null,
                category: 'all',
                recipients: [],
                notes: [],
                selectedNotes: []
            }
        },
        components: {
            Note
        },
        computed: {
            ...mapGetters({
                EmployeeId: 'getEmployeeId',
                role: 'getUserRole'            
            })
        },
        methods: {
            createNote() {
                this.visible = true
                this.selected = null
                this.category = 'create'
            },
            openNote(note) {
                this.selected = note
                this.visible = true
            },
            formatDate(date) {
                return format(parseInt(date * 1000), 'MMM. DD')
            },
            getInitials(list, note) {

                const employee = list.find(i => note.CreatedByUserID === i.EmployeeID)
                return `${employee.FirstName.charAt(0)}${employee.LastName.charAt(0)}`
            },
            isRecipient(note) {
                return note.CreatedByUserID === note.CreatedForUserID
            },
            to(list, note) {
                const person = list.find(person => person.EmployeeID === note.CreatedForUserID)
                return `${person.FirstName} ${person.LastName}`
            }, 
            from(list, note) {
                const person = list.find(person => person.EmployeeID === note.CreatedByUserID)
                return `${person.FirstName} ${person.LastName}`
            },
            truncate(text) {
                if (text && text.length > 45) return `${text.slice(0, 45)}...`
                return text
            },
            viewBy(val) {
                this.clearNote()
                this.category = val

                const id = this.EmployeeId

                const notes = this.notes

                let list = []

                switch (this.category) {
                    
                    case 'all':
                        list = notes
                        break
                    case 'my':
                        list = notes.filter(i => i.CreatedByUserID === id)
                        break;
                    case 'received':
                        list = notes.filter(i => {
                            return (i.CreatedForUserID === id && i.CreatedByUserID !== id)
                        })
                        this.$ga.event({
                            eventCategory: 'View received notes',
                            eventAction: store.getters['getDBN']
                                ? store.getters['getDBN']
                                : store.getters['admin/getSelectedSchool']['dbn'],
                            eventLabel: this.role,
                        })
                        break;
                }
                this.selectedNotes = list.sort( (a, b) => parseInt(b.CreateDate) - parseInt(a.CreateDate))
            },
            clearNote() {
                if (this.visible === true) this.visible = false
            }
            
        },
        mounted() {

            this.recipients = this.role.toLowerCase() === 'principal' ? store.getters['admin/getSchoolStaff'] : store.getters['teacher/getSchoolStaff']
            
            this.notes = store.getters['teacher/getNotes']
            this.selectedNotes = store.getters['teacher/getNotes'].sort( (a, b) => parseInt(b.CreateDate) - parseInt(a.CreateDate))

            EventBus.$on('disableVisibility', () => {
                this.visible = false
                this.selected = null
            })
        }
    }
</script>

<template>
    <div class="notes">
        <div class="notes-heading">
            <span>Notes</span>
        </div>
        <div class="notes-content">
            <div class="notes-content-info">
                <div v-if="notes.length !== 0" class="notes-tabs">
                    <ul>
                        <li v-bind:class="{ selected: category === 'all' }" @click="viewBy('all')">All </li>
                        <li v-bind:class="{ selected: category === 'my' }" @click="viewBy('my')">Personal</li>
                        <li v-bind:class="{ selected: category === 'received' }" @click="viewBy('received')">Received</li>
                        <li v-bind:class="{ selected: category === 'create' }" @click="createNote">Create</li>
                    </ul>
                </div>
                <div v-if="notes.length === 0" class="notes-content__empty">
                    <p>Write a new note for yourself or to share with someone at your school. <span @click="createNote">{{visible === true ? '-' : '+'}}</span></p>
                </div>
                <div v-else-if="category !== 'create'" class="notes-list">
                    <ul v-if="selectedNotes.length && recipients.length">
                        <li @click="openNote(note)" v-for="note in selectedNotes" :key="note.FeedBackID">
                            <div class="notes-list-avatar">
                                <span>{{getInitials(recipients, note)}}</span>
                            </div>
                            <div class="notes-list-content">
                                <div v-if="!isRecipient(note)" class="notes-list-content-meta">
                                    <p>To: {{to(recipients, note)}}</p>
                                    <p>From: {{from(recipients, note)}}</p>
                                </div>
                                <h4>{{note.FeedBackType}}</h4>
                                <p>{{truncate(note.PositiveFeedback)}}</p>
                            </div>
                            <div class="notes-list-meta">
                                <span class="notes-list-meta-date">{{formatDate(note.CreateDate)}}</span>
                                <span v-if="note.IsPublished === 1" class="notes-list-meta-status"><img src="../assets/images/Share.svg" alt="share icon" /></span>
                                <span v-else class="notes-list-meta-status"><img src="../assets/images/Lock.svg" alt="lock icon" /></span>
                            </div>
                        </li>
                    </ul>
                    <p v-else>None of your existing notes fall within this category.</p>
                </div>
                <Note :user="EmployeeId" :from="recipients.find(r => r.EmployeeID === EmployeeId)" :recipients='recipients' :note="selected ? selected: null" :visible="visible" />
            </div>
        </div>
        <div class="notes-action" v-if="!visible">
            <button @click="createNote">
                <img src="../assets/images/pencil-icon.svg" alt="pencil icon" />
            </button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
        .notes {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        .notes-list-meta {
            h3 {
                text-transform: capitalize;
            }
        }
        .notes-heading {
            display: none;
            box-sizing: border-box;
            margin: 1em 0;
            padding-bottom: 1em;
            border-bottom: 1px solid #979797;
            color: #613f75;
            font-family: 'museo_slab', sans-serif;
            * {
                display: inline-block;
                margin-right: 5px;
            }
            h1 {
                font-size: 36px;
                text-transform: uppercase;
                margin: 0 5px 0 0;
                @media screen and (min-width: 1070px) {
                    font-size: 48px;
                }
            }
            span {
                font-size: 30px;
                @media screen and (min-width: 1070px) {
                    font-size: 36px;
                }
            }
            @media screen and (min-width: 767px) {
                display: block;
            }
        }
        .notes-desktop {
             @media screen and (max-width: 1070px) {
                display: none !important;
            }
        }
        .notes-mobile {
            @media screen and (min-width: 1070px) {
                display: none;
            }
        }
        .notes-content {
            width: 100%;
            padding: 1em;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            @media screen and (min-width: 1070px) {
                flex-direction: row;
                div {
                    flex-basis: 50%;
                }
            }
            .notes-content-info {
                h2 {
                    font-size: 30px;
                    color: #613f75;
                    margin: 0 0 1em 0;
                    font-family: 'museo_sans';
                }
            }
            .notes-content-tracker {
                min-height: 400px;
                h2 {
                    margin: 0;
                    color: #613f75;
                    @media screen and (min-width: 1070px) {
                        font-size: 30px;
                    }
                }
            }
        }
        .notes-tabs {
            margin: 2em 0;
            @media screen and (min-width: 1070px) {
               margin: 0 0 1em 0;
            }
            ul {
                list-style-type: none;
                padding: 0;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                .selected {
                    background-color: #ae94bd;
                    color: #ffffff;
                }
            }
            ul li {
                flex: 1;
                padding: 10px;
                text-transform: uppercase;
                color: #ae94bd;
                font-family: 'museo_sans';
                font-size: 14px;
                border: 1px solid #ae94bd;
                text-align: center;
                cursor: pointer;
                &:first-child {
                   border-right: none;
               }
            }
        }
        .notes-content {
            flex: 1;
        }
        .notes-content__empty {
            p span {
                display: none;
                @media screen and (min-width: 1070px) {
                    display: inline;
                    position: absolute;
                    bottom: 5px;
                    right: 5px;
                    color: #000000;
                    cursor: pointer;
                }
            }
        }
        .notes-content__empty p {
            position: relative;
            align-self: center;
            background-color: #e7dbee;
            font-family: 'museo_sans';
            font-size: 18px;
            padding: 2em 1em;
            width: 250px;
            line-height: 22px;
            @media screen and (min-width: 1070px) {
               background-color: #ffffff;
               border: 7px solid #cfffe5;
               font-size: 30px;
               line-height: 36px;
               text-align: center;
            }
        }
        .notes-list {
            padding: 1em 0;
            max-height: 500px;
            overflow: auto;
            > p {
                font-size: 24px;
                text-align: center;
                line-height: 36px;
            }
            ul {
                margin: 0;
                padding: 0;
                list-style-type: none;
            }
            ul li {
                font-family: 'museo_sans';
                padding: 10px;
                margin-bottom: 1em;
                background-color: rgba(207, 255, 229, 0.62);
                color: #000000;
                display: flex;
                flex-direction: row;
                cursor: pointer;
                h3, h4 {
                    margin: 0;
                    font-size: 14px;
                }
                h4 {
                    margin-bottom: 5px;
                }
                .notes-list-avatar {
                    flex-basis: 15%;
                    display: flex;
                    align-items: center;
                    span {
                        padding: 10px;
                        border-radius: 50%;
                        background-color: #f0f0f0;
                    }
                }
                .notes-list-meta {
                    flex-basis: 10%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }
                .notes-list-content {
                    flex-basis: 75%;
                    display: flex;
                    flex-direction: column;
                    h3 {
                        text-transform: capitalize;
                    }
                    h3, h4 {
                        font-size: 14px;
                    }
                    p {
                        font-size: 12px;
                        color: #979797;
                        margin: 0;
                    }
                    h3, h4 {
                        margin: 0 0 5px 0;
                    }
                    .notes-list-content-meta {
                        margin-bottom: 10px;
                        p {
                            margin-bottom: 5px;
                        }
                    }
                }
                .notes-list-meta-date {
                    text-align: right;
                    font-size: 14px;
                }
                .notes-list-meta-status {
                    align-self: flex-end;
                }
            }
            @media screen and (min-width: 1070px) {
                width: 100%;
                box-sizing: border-box;
                border: 1px solid #b089d2;
                padding: 1em;
                margin: 0 auto 2em auto;
            }
        }
        .notes-action {
            position: fixed;
            display: flex;
            justify-content: center;
            bottom: 0;
            right: 0;
            background-color: #e7dbee;
            width: 70px;
            height: 70px;
            z-index: 1;
            button {
                background-color: transparent;
                border: none;
            }
            @media screen and (min-width: 1070px) {
               display: none;
            }
        }
    }
</style>